import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import ReceiptIcon from '@material-ui/icons/Receipt';
// Components
import PurchaseOrderApprovalTable from "./PurchaseOrderApprovalTable"; //reused table component
import PDFFile from "./PDFFile";

//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import {isLoggedIn} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";


const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
});

const PurchaseApprovalHistoryView = () => {
	const { pono, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState(null);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [notes, setNotes] = useState('');

	const [encoder, setEncoder] = useState('');
	const [approver, setApprover] = useState('');
	const [poStatus, setPOStatus] = useState('');

	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const DownloadPdf = ( {dateOfDel, delTo, mop, contact, address, pono, items, notes, shipping, subtotal, grandTotal, encoder, approver  } ) => {
		return (
		<PDFDownloadLink 
			document={
			<PDFFile dateOfDel={dateOfDel} delTo={delTo} mop={mop} contact={contact} address={address} pono={pono} items={items} notes={notes} shipping={shipping} subtotal={subtotal} grandTotal={grandTotal} encoder={encoder} approver={approver} />} 
			fileName="purchase-order.pdf">
			{({ loading }) => (loading ? 'loading...' : <Button variant="contained" color="primary">Print PDF</Button> )}
		</PDFDownloadLink>
		)
	}

	const data = async () => {
		const po_details = await axios.get(process.env.REACT_APP_API_URL+'get_po_details', {
			params:{
				pono: pono,
				jc_u_idno: branchidno
			}
		});
		if(po_details){
			setItems(po_details.data.data[0].item_info);
			setSupplierInfo(po_details.data.data[1].po_info);
			setShipTotal(po_details.data.data[1].po_info.shipping);
			setPoTotal(po_details.data.data[1].po_info.subtotal);
			setGrandTotal(po_details.data.data[1].po_info.total);
			setNotes(po_details.data.data[1].po_info.notes);
			setEncoder(po_details.data.data[1].po_info.encoder);
			setApprover(po_details.data.data[1].po_info.approver);
			setPOStatus(po_details.data.data[1].po_info.po_status)
		}
		//setTotal(parseInt(poTotal) + parseInt(shipTotal));
		
	};	

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<NavLink to={"/purchases"}><h2 style={{color:"black"}}>Purchases</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/purchases/purchases-order-approval-history"}><h2 style={{color:"black"}}>Purchase Approval History</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Purchase Order #{pono}</h2>
				{/* <h2>supplier id: {supid} - delivery_date: {delivery_date}</h2> test if param values were passed*/}
			</div>
			     {supplierInfo?(			<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Purchase Order Approval History Information
								</div>
								<div className={classes.title}>
									{supplierInfo.purchase_from || "Purchased From"}
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								{/* <PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/> */}
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								{
									poStatus === 2 ? //Check if PO is approved
									<DownloadPdf 
									dateOfDel	= {supplierInfo.delivery_date || "Date of delivery"}
									delTo		= {supplierInfo.purchase_from || "Purchased From"}
									mop			= {supplierInfo.mode_of_payment || "Mode of Payment"}
									contact		= {supplierInfo.contact_no || "Contact Number"}
									address		= {supplierInfo.address || "Address"}
									pono		= {pono}
									items		= {items}
									notes		= {notes || ''}
									shipping	= {numeral(shipTotal).format('0,0.00')}
									subtotal	= {numeral(poTotal).format('0,0.00')}
									grandTotal	= {numeral(grandTotal).format('0,0.00')}
									encoder 	= {encoder}
									approver	= {approver}
									/>
									: ''
								}
								{/* <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/> */}
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2}  className={classes.infoTitle}>
									Date of Delivery: 
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.delivery_date || "Date of delivery"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2}  className={classes.infoTitle}>
									Deliver To: 
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.purchase_from || "Purchased From"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2}  className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.mode_of_payment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2}  className={classes.infoTitle}>
									Contact Number:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.contact_no || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2}  className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplierInfo.address || "Address"}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderApprovalTable items={items} setItems={setItems}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Shipping: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(shipTotal).format('0,0.00')}	
									</div>							
								</div>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(poTotal).format('0,0.00')}	
									</div>
								</div>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(grandTotal).format('0,0.00')}	
									</div>
								</div>	
							</div>
						</div>
						<TextField
							label="Notes"
							disabled={true}
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
			</div>
		):(<Preloader />)}

		</div>
	);
};

export default PurchaseApprovalHistoryView;
